module.exports = __webpack_public_path__ + "building.cab11b74.png";


//////////////////
// WEBPACK FOOTER
// ./client/images/building/preview/building.png
// module id = 632
// module chunks = 0